import type { CustomerConfig } from "../../types";

export const gitlabConfig: CustomerConfig = {
	id: "gitlab",
	name: "GitLab",
	shortName: "GitLab",
	accessTokens: ["993440ce17fa40038298457e58f667de"],
	accessExpiry: new Date("2026-05-09T23:59:59Z"),
	onsiteDates: "April 14, 2026",
	theme: {
		accentColor: "#f97316",
		accentColorLight: "#fb923c",
		secondaryAccent: "#7c3aed",
		pathColorFrom: "#f97316",
		pathColorTo: "#7c3aed",
		slideAccentBar: "#f97316",
	},
	logos: {
		customer: "/assets/logos/gitlab.png",
		null: "/null/logo.white.svg",
	},
	demoUrl: "https://app.dev.null.autos",
	demoLabel: "Launch Null Autos Platform",
	confidentialityNotice:
    "CONFIDENTIAL — Any disclosure, use, reproduction, or distribution of this information without the express written consent of Null Autos is strictly prohibited.",
};
